import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import { AppConfig } from '../../../config';

@Injectable()
export class OtkazaneEdukacijeService {

  constructor(private _http: Http) { }

  dohvatiOtkazaneEdukacije(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_otkazane_edukacije', a)
    .map(res => res.json()); 
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/otkazaneedukacije/otkazaneedukacije.service.ts